import twitter_TApng_img from "../../../assets/images/twitter_TA.png";

import youtube_TApng_img from "../../../assets/images/youtube_TA.png";

import linkedIn_TApng_img from "../../../assets/images/linkedIn_TA.png";

import React, {useState, useEffect} from 'react';
import { makeStyles } from "@material-ui/core/styles";
import facebook from '../../../assets/images/facebook_TA.png';
import {thumborImageUrl, devConsolelog} from '../../../Utility';
import insargaramTa from '../../../assets/images/instagram_TA.png';
const useStyles = makeStyles(theme => ({
  socialMediaContainer: {
    display:'flex',
    flexDirection:'row',
  //  justifyContent:'space-between',
    // width: '25%', 
    padding: '10px 0px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },
  columnFlex: {
    flexDirection: 'column'
  },
  socialMedia: {
    paddingRight: theme.spacing(2)
  }
}))

export default ({social_media_links = [], columnFlex=false}) => {
  const classes = useStyles();
  const [socialLinks, setSocialLinks] = useState({});
  devConsolelog('social_media_links ', social_media_links, socialLinks)

  useEffect(() => {
    if(social_media_links.length == 0) return;
    let socialLinks = {}
    social_media_links.forEach(item => {
     if(item.type && item.link) socialLinks[item.type.toLowerCase()] = item.link;
    })
    setSocialLinks(socialLinks);
  }, [social_media_links])


  return (
    <div className={`${classes.socialMediaContainer} ${columnFlex ? classes.columnFlex : ''} `}>
      {socialLinks['facebook'] &&  <a className={classes.socialMedia} href={socialLinks['facebook']} target='_blank'><img src={facebook} height='25' width='25' /></a>}
      {socialLinks['youtube'] && <a className={classes.socialMedia} href={socialLinks['youtube']} target='_blank'><img src={youtube_TApng_img} height='25' width='25' /></a>}
      {socialLinks['twitter'] && <a className={classes.socialMedia} href={socialLinks['twitter']} target='_blank'><img src={twitter_TApng_img} height='25' width='25' /></a>}
      {socialLinks['instagram'] && <a className={classes.socialMedia} href={socialLinks['instagram']} target='_blank'><img src={insargaramTa} height='25' width='25' /></a>}
      {socialLinks['linkedin'] && <a className={classes.socialMedia} href={socialLinks['linkedin']} target='_blank'><img src={linkedIn_TApng_img} height='25' width='25' /></a>}
    </div>
  )
}
